import React, { useState } from "react";
import { Button } from "antd";
import { useLocation } from "react-router-dom";
import Dashboard from "./Dashboard";
import ManualAssignment from "./ManualAssignment";
import EqualDistribution from "./EqualDistribution";
import DynamicAllocation from "./DynamicAllocation";
import usePageAccess from "../../../Utlis/usePageAccess";

const CreditsBilling = () => {
  const { canEdit } = usePageAccess("credits-billing");
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "Dashboard",
  );

  const [btnConfigs, setBtnConfigs] = useState([]);

  const tabs = [
    "Dashboard",
    "Manual Assignment",
    "Equal Distribution",
    "Dynamic Allocation",
  ];

  return (
    <div className="report system-configue">
      <div className="header-wrapper">
        <div className="report-navigation">
          <div className="nav-tabs">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`nav-item ${activeTab === tab ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(tab);
                  setBtnConfigs([]);
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="reports-controls">
        <div className="section-title">{activeTab}</div>

        <div className="button-group">
          {(canEdit ? btnConfigs : []).map((btn, index) => (
            <Button
              key={index}
              type={btn.type || "primary"}
              icon={btn.icon}
              onClick={btn.onClick}
              disabled={btn.disabled}
              title={btn.title}
              className={`custom-action-btn ${btn.className || ""}`}
            >
              {btn.text}
            </Button>
          ))}
        </div>
      </div>

      <div className="tab-content">
        {activeTab === "Dashboard" && (
          <Dashboard setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Manual Assignment" && (
          <ManualAssignment setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Equal Distribution" && (
          <EqualDistribution setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Dynamic Allocation" && (
          <DynamicAllocation setBtnConfigs={setBtnConfigs} />
        )}
      </div>
    </div>
  );
};

export default CreditsBilling;
